<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                   <sidebar></sidebar>
                </el-aside>
                <el-main>
                    <contTitle  :obj="obj" :contTitle="contTitle"></contTitle>
                    <companySide class="mt-30" :isButton="isButton"></companySide>
                    <div class="mt-30">
                        <contTitle  :obj="obj" :contTitle="contTitles"></contTitle>
                        <div class="mt-30">
                            <el-form ref="form" :model="form"  :rules="rules" label-width="100px" >
                                 <el-form-item label="邮箱地址:" prop="email" style="width:80%;">
                                    <el-input v-model="form.email" clearable></el-input>
                                 </el-form-item>
                                 <el-form-item label="开票信息:" style="width:80%;">
                                    <el-input type="textarea" v-model="form.reason"></el-input>
                                 </el-form-item>
                                  <el-form-item class="inv_box">
                                    <el-button type="primary" @click="onSubmit('form')">立即申请</el-button>
                                </el-form-item>

                            </el-form>


                        </div>
                    </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {getToken} from '@/utils/auth'
import {sendface,sendinvoice,getinvoicelist} from '@/api/coment'
import sidebar from '../../common/sidebar'
import companySide from '../../common/companySide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import contTitle from '../../common/contTitle'
import { linkus } from '../../api/coment'
export default {
  components:{
     sidebar,companySide,commBanner,titleHead,contTitle
  },
  data(){
    //验证邮箱规则
    var checkEmail = (rule, value, callback) => {
      // 验证邮箱的正则表达式
       const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
       if(!value){
        return callback(new Error('邮箱不能为空'))
       }
       setTimeout(() => {
          if (regEmail.test(value)) {
            callback()
          } else {
            callback(new Error('请输入正确的邮箱格式'))
          }
        }, 100)
     };
      return{
        headTitle:'发票申请',
        contTitle:'企业基本信息',
        contTitles:'发票申请',
        obj:{
           title:'我的发票',
           isShow:false,
           isColor:false,
           roleType:3,
           personalType:9
        },
        isButton:false,
        form:{
          email:'',
          reason:'' //原因
        },
        rules:{
          email:[{required:true, validator: checkEmail, trigger: 'blur' }],
          reason:[{ required: true, message: "请输入开票信息", trigger: "blur" }]
        },
        id:'',
        user:{}

      }
  },
  created(){
     this.id = this.$store.state.user.userInfo.data.userId
     this.user = this.$store.state.user.userInfo.data2;
  },
  methods:{
    onSubmit(formName){
        this.$refs[formName].validate((valid)=>{
          if(valid){
            if(this.user.id == 5){
                let params = {
                    userid:this.id,
                    content:this.form.email,
                    msg:this.form.reason
                };
               sendinvoice(params).then((res)=>{
                if(res.code == 0){
                 this.$message({
                    message:'等待审核',
                    type: 'success',
                    duration:3000,
                    onClose:()=>{
                      this.$router.push('/corporate_invoice')
                    }
                 });
                }
             }).catch((err)=>{})
            }else{
              this.$message({
                message:'你不是企业V会员，赶快去升级哦！',
                type: 'info',
                duration:3000
              });
            }
          }else{
            return false;
          }
        });
    },
  }
}
</script>
<style scoped="scoped">
.el-aside{
    height:100%;
}
.mt-30{
    margin-top: 30px;
}
.el-textarea>>>.el-textarea__inner{
  height: 180px !important;
}
.inv_box{
  text-align:left;
}
.inv_box >>> .el-button{
   width: 110px;
}
.inv_box >>>.el-button--primary{
  background-color: #68be31;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/view/company/corporate_invoiceAdd.vue